import { downloadSecMasterData } from "../../http/api";

export const MAX_DOWNLOAD_ROWS = 500000;

const triggerBlobDownload = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const downloadSecMasterCSV = async (
  token,
  _totalElements,
  _selectedColumns,
  format = "xlsx",
  sortConfig = null,
  filters = null
) => {
  try {
    const payload = {
      ...(sortConfig?.columnToSort && {
        columnToSort: sortConfig.columnToSort,
        sortingDirection: sortConfig.sortingDirection,
      }),
      ...(filters || {}),
    };

    // The backend generates the file in the requested format (csv or xlsx) and streams it back.
    // We just save the blob as-is — no in-browser parsing/conversion (that OOM-crashed the tab on
    // large exports). For xlsx the response is a real .xlsx; for csv it's gzip-decoded by the browser.
    const fileFormat = format === "csv" ? "csv" : "xlsx";
    const blob = await downloadSecMasterData(token, payload, fileFormat);
    if (!blob) return;

    // Derive the extension from what the server ACTUALLY returned (blob.type === response
    // Content-Type), not from the requested format. If they ever mismatch (e.g. server falls back
    // to CSV), this still saves a file the OS/Excel can open instead of a mislabelled .xlsx.
    const contentType = (blob.type || "").toLowerCase();
    let ext;
    if (contentType.includes("spreadsheetml") || contentType.includes("ms-excel")) {
      ext = "xlsx";
    } else if (contentType.includes("csv") || contentType.includes("text/plain")) {
      ext = "csv";
    } else {
      ext = fileFormat; // unknown/generic content-type → trust the requested format
    }

    triggerBlobDownload(blob, `sec_master_data.${ext}`);
  } catch (error) {
    console.error("Error downloading sec master data:", error);
    throw error;
  }
};
